import React from 'react';
import { RedditPost } from '../types/reddit';
import { MessageSquare, ThumbsUp } from 'lucide-react';

interface ArticlePreviewProps {
  post: RedditPost;
}

const ArticlePreview: React.FC<ArticlePreviewProps> = ({ post }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
      <a href={post.url} target="_blank" rel="noopener noreferrer" className="text-xl font-bold text-gray-800 hover:text-blue-600">
        {post.title}
      </a>
      <p className="text-gray-600 mt-2">{post.selftext.substring(0, 150)}...</p>
      <div className="flex items-center justify-between mt-4 text-sm text-gray-500">
        <div className="flex items-center space-x-4">
          <div className="flex items-center">
            <ThumbsUp size={16} className="mr-1" />
            <span>{post.score}</span>
          </div>
          <div className="flex items-center">
            <MessageSquare size={16} className="mr-1" />
            <span>{post.num_comments}</span>
          </div>
        </div>
        <span className="font-medium">{post.author}</span>
      </div>
    </div>
  );
};

export default ArticlePreview;